import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosinterceptor";
import { toast, ToastContainer } from 'react-toastify';

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

const initialState = {
  codeAssistData: [],
  groperVersionData :[],
    getGrouperVersionsStatus: STATUS.IDLE,
    getGrouperVersionsError: null,

    addRuleVersionStatus: STATUS.IDLE,
    addRuleVersionError: null,

    deleteHealthContructorStatus: STATUS.IDLE,
    deleteHealthContructorError: null,
    groperVersionDataStatus:STATUS.IDLE,
    groperVersionDataError:null,
    updateVesrionandhealthfundNameStatus:STATUS.IDLE,
    updateVesrionandhealthfundNameError:STATUS.IDLE

};

export const getGrouperVersionsData = createAsyncThunk(
  "grouperSettings/getGrouperVersionsData",
  async (endpoint, { fulfillWithValue, rejectWithValue }) => {
    try {
       const response = await axiosInstance.get(
     `/setting_multi_drg?module=${endpoint}`
      );
      console.log(response.data, "response");
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const getAddNewRuleAndVersion = createAsyncThunk(
  "grouperSettings/getAddNewRuleAndVersion",
  async (payload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        "/setting_multi_drg_create",
        payload
      );
      console.log(response);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error while adding rule/version");
    }
  }
);

export const getDeleteHealthContructorandGrouperVersion = createAsyncThunk(
  "grouperSettings/getDeleteHealthContructorandGrouperVersion",
  async (deletePayload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        "/setting_multi_drg_delete_healthfund",
        { data: deletePayload }
      );
      console.log(response);
      return fulfillWithValue(response.data);
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error while deleting");
    }
  }
);


export const getGrouperVersions =  createAsyncThunk(
  "grouperSettings/getGrouperVersions",
  async(_,{fulfillWithValue,rejectWithValue}) =>{
     try{
      const response = await axiosInstance.get("/setting_multi_drg_grouper_version_list")
      console.log(response)
      return fulfillWithValue(response.data)
     }catch(error){
        return rejectWithValue(error.response?.data)
     }
  }
)

export const getUpdateGrouperVersionandhelthfundName = createAsyncThunk(
  "grouperSettings/getUpdateGrouperVersionandhelthfundName",
   async(payload,{fulfillWithValue,rejectWithValue}) =>{
     try{
      const response = await axiosInstance.put("/setting_multi_drg_update",payload)
      // console.log(response.data)
      return fulfillWithValue(response?.data)
     }catch(error){
        return rejectWithValue(error.response?.data)
     }
  }
)

const grouperSlice = createSlice({
  name: "grouperSettings",
  initialState,
  reducers: {
    resetData: (state) => {
      state.codeAssistData = [];
    },
  },
  extraReducers: (builder) => {
    builder
      //  getGrouperVersionsData
      .addCase(getGrouperVersionsData.pending, (state) => {
        state.getGrouperVersionsStatus = STATUS.LOADING;
        state.getGrouperVersionsError = null;
      })
      .addCase(getGrouperVersionsData.fulfilled, (state, action) => {
        state.getGrouperVersionsStatus = STATUS.SUCCEEDED;
        state.codeAssistData = action.payload;
      })
      .addCase(getGrouperVersionsData.rejected, (state, action) => {
        state.getGrouperVersionsStatus = STATUS.FAILED;
        state.error = action.payload;
      })

      // getAddNewRuleAndVersion
      .addCase(getAddNewRuleAndVersion.pending, (state) => {
        state.addRuleVersionStatus = STATUS.LOADING;
        state.addRuleVersionError = null;
      })
      .addCase(getAddNewRuleAndVersion.fulfilled, (state,action) => {
        state.addRuleVersionStatus = STATUS.SUCCEEDED;
        const message = action.payload.Status 
        setTimeout(() =>{
          toast.success(message)
        },100)
      })
      .addCase(getAddNewRuleAndVersion.rejected, (state, action) => {
        state.addRuleVersionStatus = STATUS.FAILED;
        state.addRuleVersionError = action.payload;
      })

      // getDeleteHealthContructorandGrouperVersion
      .addCase(getDeleteHealthContructorandGrouperVersion.pending, (state) => {
        state.deleteHealthContructorStatus = STATUS.LOADING;
        state.deleteHealthContructorError = null;
      })
      .addCase(getDeleteHealthContructorandGrouperVersion.fulfilled, (state) => {
        state.deleteHealthContructorStatus = STATUS.SUCCEEDED;
      })
      .addCase(getDeleteHealthContructorandGrouperVersion.rejected, (state, action) => {
        state.deleteHealthContructorStatus = STATUS.FAILED;
        state.deleteHealthContructorError = action.payload;
      })

       // getGrouperVersions
      .addCase(getGrouperVersions.pending, (state) => {
        state.groperVersionDataStatus = STATUS.LOADING;
        state.groperVersionDataError = null;
      })
      .addCase(getGrouperVersions.fulfilled, (state,action) => {
        state.groperVersionDataStatus = STATUS.SUCCEEDED;
        state.groperVersionData = action.payload;
      })
      .addCase(getGrouperVersions.rejected, (state, action) => {
        state.groperVersionDataStatus = STATUS.FAILED;
        state.groperVersionDataError = action.payload;
      })

        // getUpdateGrouperVersionandhelthfundName
      .addCase(getUpdateGrouperVersionandhelthfundName.pending, (state) => {
        state.updateVesrionandhealthfundNameStatus = STATUS.LOADING;
        state.updateVesrionandhealthfundNameError = null;
      })
      .addCase(getUpdateGrouperVersionandhelthfundName.fulfilled, (state,action) => {
        state.updateVesrionandhealthfundNameStatus = STATUS.SUCCEEDED;
        const updateMessage = action.payload.msg
        console.log(updateMessage) 
        setTimeout(() =>{
          toast.success(updateMessage)
        },100)
        // state.groperVersionData = action.payload;
      })
      .addCase(getUpdateGrouperVersionandhelthfundName.rejected, (state, action) => {
        state.updateVesrionandhealthfundNameStatus = STATUS.FAILED;
        state.updateVesrionandhealthfundNameError = action.payload;
      });
  },
});

export const { resetData } = grouperSlice.actions;
export default grouperSlice.reducer;
